import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CartSidebar from '@/components/feature/CartSidebar';
import ImageGallery from './components/ImageGallery';
import ProductInfo from './components/ProductInfo';
import ReviewsSection from './components/ReviewsSection';
import ProductCard from '@/pages/products/components/ProductCard';
import { products } from '@/mocks/products';

export default function ProductPage() {
  const { id } = useParams<{ id: string }>();
  const product = products.find((p) => p.id === id);
  const related = products.filter((p) => p.id !== id && p.category === product?.category).slice(0, 4);

  if (!product) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F7F8F9] font-inter gap-4">
        <div className="w-16 h-16 flex items-center justify-center">
          <i className="ri-error-warning-line text-5xl text-gray-300"></i>
        </div>
        <h2 className="font-outfit font-bold text-[#1A1A1A] text-2xl">Product not found</h2>
        <Link to="/products" className="bg-[#C4FF61] text-[#1A1A1A] font-outfit font-bold px-6 py-3 rounded-full hover:bg-[#a8e84a] transition-colors cursor-pointer whitespace-nowrap text-sm">
          Back to Shop
        </Link>
      </div>
    );
  }

  return (
    <div className="font-inter min-h-screen bg-white">
      <Navbar />

      {/* Breadcrumb */}
      <div className="bg-[#F7F8F9] pt-24 pb-4 px-6 md:px-12">
        <nav className="flex items-center gap-2 text-xs font-inter text-gray-400">
          <Link to="/" className="hover:text-[#1A1A1A] transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/products" className="hover:text-[#1A1A1A] transition-colors cursor-pointer">Shop</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-[#1A1A1A]">{product.name}</span>
        </nav>
      </div>

      {/* Product Detail */}
      <div className="px-6 md:px-12 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <ImageGallery images={product.images} productName={product.name} />
          </div>
          <div>
            <ProductInfo product={product} />
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="px-6 md:px-12">
        <div className="h-px bg-gray-100"></div>
      </div>

      {/* Reviews */}
      <ReviewsSection
        productId={product.id}
        rating={product.rating}
        reviewCount={product.reviewCount}
      />

      {/* Related Products */}
      {related.length > 0 && (
        <div className="bg-[#F7F8F9] py-16 px-6 md:px-12">
          <h2 className="font-outfit font-black text-[#1A1A1A] text-2xl md:text-3xl mb-8">
            You Might Also Like
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
            {related.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
      )}

      <Footer />
      <CartSidebar />
    </div>
  );
}
